import { render, staticRenderFns } from "./SellerManagement.vue?vue&type=template&id=ec147faa&scoped=true"
import script from "./SellerManagement.vue?vue&type=script&lang=js"
export * from "./SellerManagement.vue?vue&type=script&lang=js"
import style0 from "./SellerManagement.vue?vue&type=style&index=0&id=ec147faa&prod&lang=css"
import style1 from "./SellerManagement.vue?vue&type=style&index=1&id=ec147faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec147faa",
  null
  
)

export default component.exports